import React from 'react';
import { useTranslation } from "react-i18next";
import { Input, Checkbox, NumericTextBox } from '@progress/kendo-react-inputs';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { Button } from '@progress/kendo-react-buttons';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';


export default function MovementsDetailsComponents() {

    const { t } = useTranslation();
    const [activo, setActivo] = React.useState('');
    const [activo1, setActivo1] = React.useState('');
    const [activo2, setActivo2] = React.useState('');

    const [value, setValue] = React.useState(new Date());

    const initialData = [
        {
            ProductID: 1,
            ProductName: "Location A",
            FirstOrderedOn: new Date(2024, 4, 10),
            UnitsInStock: 20,
            Discontinued: false,
        },
        {
            ProductID: 2,
            ProductName: "Location B",
            FirstOrderedOn: new Date(2024, 5, 2),
            UnitsInStock: 15,
            Discontinued: true,
        },
        {
            ProductID: 3,
            ProductName: "Location C",
            FirstOrderedOn: new Date(2024, 2, 25),
            UnitsInStock: 10,
            Discontinued: false,
        }
    ];

    const [data, setData] = React.useState(initialData);
    const [originalData, setOriginalData] = React.useState(initialData);
    const [hasChanges, setHasChanges] = React.useState(false);

    // Al hacer clic en una fila, habilita edición
    const rowClick = event => {
        const id = event.dataItem.ProductID;
        setData(data.map(item =>
            item.ProductID === id ? { ...item, inEdit: true } : item
        ));
    };

    // Maneja cambios en celdas editables
    const handleItemChange = event => {
        const id = event.dataItem.ProductID;
        const field = event.field || '';
        const newData = data.map(item =>
            item.ProductID === id
                ? { ...item, [field]: event.value }
                : item
        );
        setData(newData);
        setHasChanges(true);
    };

    // Controla el estado de edición de una fila
    const handleEditChange = event => {
        const id = event.dataItem.ProductID;
        setData(data.map(item =>
            item.ProductID === id
                ? { ...item, inEdit: event.value }
                : item
        ));
    };

    // Agrega un nuevo registro
    const addRecord = () => {
        const id = Math.max(...data.map(d => d.ProductID), 0) + 1;
        const newRecord = {
            ProductID: id,
            ProductName: '',
            FirstOrderedOn: new Date(),
            UnitsInStock: 0,
            Discontinued: false,
            inEdit: true
        };
        setData([newRecord, ...data]);
        setHasChanges(true);
    };

    const saveChanges = () => {
        const cleanedData = data.map(item => ({ ...item, inEdit: false }));
        setData(cleanedData);
        setOriginalData(cleanedData);
        setHasChanges(false);
    };

    const cancelChanges = () => {
        setData(originalData.map(item => ({ ...item, inEdit: false })));
        setHasChanges(false);
    };

    const removeItem = (dataItem) => {
        setData(data.filter(item => item.ProductID !== dataItem.ProductID));
        setOriginalData(originalData.filter(item => item.ProductID !== dataItem.ProductID));
        setHasChanges(true);
    };

    const changeDate = ({ value }) => {
        setValue(value);
    };

    return (
        <div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3 px-4">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                        </div>

                        <div className="container py-4 px-3 px-md-5">
                            <div className="card mb-4 border-0 shadow-sm">
                                <div className="card-body">
                                    <div className="row g-3 mb-3">
                                        <div className="col-12 col-md-4">
                                            <Input
                                                label={t("Global_Label_Text_Description")}
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <Input
                                                label={t("Global_Label_Text_Farms")}
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <Input
                                                label={t("Global_Label_Text_Guy")}
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row g-3">
                                        <div className="col-12 col-md-6">
                                            <DatePicker
                                                label={t("Global_Label_Text_Power_Movement_Date")}
                                                value={value}
                                                onChange={changeDate}
                                                width="100%"
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <NumericTextBox
                                                label={t("Global_Label_Text_Animals")}
                                                style={{ width: "100%" }}
                                                defaultValue={0}
                                                min={0}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card mb-4 border-0 shadow-sm">
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-12 col-md-4">
                                            <Input
                                                label={t("Global_Label_Text_Been")}
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <Input
                                                label={t("Global_Label_Text_Origin")}
                                                style={{ width: "100%" }}
                                            />
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <NumericTextBox
                                                label={t("Global_Label_Text_Average_Weight") + " (Kg)"}
                                                style={{ width: "100%" }}
                                                defaultValue={0}
                                                min={0}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    <h6 className="mb-3">{t("Global_Label_Text_Options")}</h6>
                                    <div className="row g-3">
                                        <div className="col-12 col-md-4">
                                            <FloatingLabel label={t("Global_Label_Text_Closed")}>
                                                <Checkbox
                                                    defaultChecked={false}
                                                    value={activo}
                                                    onChange={(e) => setActivo(e.target.value)}
                                                />
                                            </FloatingLabel>
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <FloatingLabel label={t("Global_Label_Text_Programmed")}>
                                                <Checkbox
                                                    defaultChecked={false}
                                                    value1={activo1}
                                                    onChange={(e) => setActivo1(e.target.value1)}
                                                />
                                            </FloatingLabel>
                                        </div>
                                        <div className="col-12 col-md-4">
                                            <FloatingLabel label={t("Global_Label_Text_Exported")}>
                                                <Checkbox
                                                    defaultChecked={false}
                                                    value2={activo2}
                                                    onChange={(e) => setActivo2(e.target.value2)}
                                                />
                                            </FloatingLabel>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <Grid
                            style={{ height: '420px' }}
                            data={data}
                            dataItemKey="ProductID"
                            editField="inEdit"
                            onItemChange={handleItemChange}
                            onEditChange={handleEditChange}
                            onRowClick={rowClick}
                        >
                            <GridToolbar>
                                <Button onClick={addRecord}>
                                    Add New
                                </Button>
                                <Button onClick={saveChanges} disabled={!hasChanges} style={{ marginLeft: 10 }}>
                                    Save Changes
                                </Button>
                                <Button onClick={cancelChanges} disabled={!hasChanges} style={{ marginLeft: 10 }}>
                                    Cancel Changes
                                </Button>
                            </GridToolbar>
                            <Column
                                cell={(props) => (<td>
                                    <Button onClick={() => removeItem(props.dataItem)}>
                                        Eliminar
                                    </Button>
                                </td>)} width="120px" />
                            <Column field="ProductID" title="Id" width="50px" editable={false} />
                            <Column field="ProductName" title="Name" />
                            <Column field="FirstOrderedOn" title="First Ordered" editor="date" format="{0:d}" />
                            <Column field="UnitsInStock" title="Units" width="150px" editor="numeric" />
                            <Column field="Discontinued" title="Discontinued" editor="boolean" />
                        </Grid>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="d-flex justify-content-end mb-3">
                        <Button className="action-button me-lg-11">{t("Global_Label_Text_Save")}</Button>
                    </div>
                </div>
            </div>

        </div>
    );
}
